import { z } from 'zod';

/**
 * Search form schema for 加療期間切れリスト.
 *
 * Client-side rules mirror RA2 treatment_period.blade.php JS validation:
 *   - 期間開始日 / 終了日 are required to submit 検索
 *   - when 施術師 radio = 指定あり ("2"), massager_id must be chosen
 *
 * The A2/R2 alert message differs ("はり・きゅう師" vs "マッサージ師") —
 * callers pass `massagerLabel` and we interpolate it into the error.
 */
export const consentTreatmentPeriodSearchSchema = z.object({
  search_treatement_from: z.string().min(1, '【期間開始日】を入力してください'),
  search_treatement_to: z.string().min(1, '【期間終了日】を入力してください'),
  massager: z.enum(['1', '2']).default('1'),
  massager_id: z.number().int().positive().nullable().optional(),
}).superRefine((data, ctx) => {
  if (data.massager === '2' && !data.massager_id) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['massager_id'],
      // Label interpolated by caller — Recepro A: はり・きゅう師 / Recepro R: マッサージ師.
      message: '施術師を選択してください',
    });
  }
});

export type ConsentTreatmentPeriodSearchFormData = z.infer<typeof consentTreatmentPeriodSearchSchema>;
